import React from 'react'
import { Skeleton, Stack } from '@mui/material'

export const ChewyItemSkeleton = () => (
  <Stack direction="row" spacing={0.5}>
    <Skeleton height={30} width={20} />
    <Skeleton height={30} width={120} />
  </Stack>
)
